export type IdentityProvider = "AZURE_AD" | "OKTA";

const envProvider = process.env.REACT_APP_AUTH_IDENTITY_PROVIDER;

/**
 * Normalize env value:
 * - empty string
 * - undefined
 * - null
 * → defaults to AZURE_AD
 */
export const AUTH_IDENTITY_PROVIDER: IdentityProvider =
    envProvider === "OKTA" || envProvider === "AZURE_AD"
        ? envProvider
        : "OKTA"; // DEFAULT VALUE